// extracted by mini-css-extract-plugin
export default {"close":"MobileCloseButton_close__oeSe4"};